module.exports = __webpack_public_path__ + "static/media/EstadoAgenteTransfer.cf233047.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/EstadoAgente/EstadoAgenteTransfer.svg
// module id = 1771
// module chunks = 0